import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import { useAppContext } from "../context/appContext";
import { Mixpanel } from "../utils/Mixpanel";
import TokenService from "../utils/TokenService";
import MainMenu from "../components/MainMenu";
import authApi from "../service/IdApi";
import { useSearchParams } from "react-router-dom";

const initialState = {
    code: ""
};

const Register = () => {
    const { displayAlert } = useAppContext();
    const navigate = useNavigate();
    const [values, setValues] = useState(initialState);
    const [mobileTopbarActive] = useState(false);
    const [changesMade, setChangesMade] = useState(false);
    const [searchParams] = useSearchParams();
    const [isProcessing, setIsProcessing] = useState(false);

    const handleChange = (e) => {
        setChangesMade(true);
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const resendCode = (e) => {
        authApi.get("auth/verification/send-email", "", {
            withCredentials: true,
        }).then((response) => {
            // Mixpanel.track("Resend Email Verification Code - successful");
            displayAlert("success", "Success", "A new code was sent to your email address");
            return response.data;
        }).catch(function (error) {
            // Mixpanel.track("Resend Email Verification Code - API error");
            displayAlert("error", "Error", "Failed to send email. Please try again later");
            return;
        });
    }

    const verifyEmailApi = useMutation((values) => {
        var body = {};
        body.code = values.code.trim();
        try {
            const data = authApi.post("auth/verification/verify-email", body, {
                withCredentials: true,
            }).then((response) => response.data);
            return data;
        } catch (error) {
            throw error;
        }
    });

    const onSubmit = (e) => {
        e.preventDefault();
        if (!values.code) {
            displayAlert("error", "Error", "Please enter the code from your email");
            Mixpanel.track("UI Email Verification - failed UI validation");
            return;
        }
        setIsProcessing(true);
        verifyEmailApi.mutate(values, {
            onError: (error, variables, context) => {
                if (error.response.status === 410) {
                    displayAlert("error", "Unexpected Error", "Verification code has expired.");
                    Mixpanel.track("UI Email Verification - failed as code is expired");
                }
                else if (error.response.status === 404) {
                    displayAlert("error", "Unexpected Error", "Invalid verification code.");
                    Mixpanel.track("UI Email Verification - failed invalid verification code");
                }
                else {
                    displayAlert("error", "Unexpected Error", "Please try again later");
                    Mixpanel.track("UI Email Verification - failed API error");
                }
                setIsProcessing(false);
            },
            onSuccess: (data) => {
                TokenService.setAccessToken(data.userAccessToken);
                TokenService.setRefreshToken(data.userRefreshToken);
                displayAlert("success", "Success", "Email verification successful");
                Mixpanel.track("UI Email Verification - successful");
                if (TokenService.isPending2fa()) {
                    navigate("/verify-2fa");
                } else if (TokenService.is2faSetupRequired()) {
                    navigate("/setup-2fa");
                } else if (TokenService.is2faSetupEncouraged()) {
                    navigate("/setup-2fa");
                } else if (!TokenService.isUserProfileComplete()) {
                    navigate("/complete-profile");
                } else {
                    TokenService.redirectUser(data.providerCount);
                }
            },
        });
    };

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "pages-body",
        "login-page",
        "flex",
        "flex-column",
        "layout-menu-cyan layout-topbar-cyan",
        {
            "layout-topbar-mobile-active": mobileTopbarActive,
            "p-input-outlined": "outlined"
        }
    );

    useEffect(() => {
        if (TokenService.isLoggedIn()) {
            navigate("/account/select-provider");
            return;
        }
        if (TokenService.isAuthenticated() && !TokenService.isPendingEmailVerification()) {
            if (TokenService.isPending2fa()) {
                navigate("/verify-2fa");
            } else if (TokenService.is2faSetupRequired()) {
                navigate("/setup-2fa");
            } else if (TokenService.is2faSetupEncouraged()) {
                navigate("/setup-2fa");
            }
            return;
        }
        // Mixpanel.track_links();
        var _code = searchParams.get("code");
        if (_code && _code !== "") {
            setValues({ ...values, ["code"]: _code });
            setChangesMade(true);
        }
    }, []);

    return (
        <div className={layoutContainerClassName}>
            <MainMenu />
            <div className="align-self-center mt-auto mb-auto w-full" style={{maxWidth: "500px"}}>
                <div className="pages-panel card flex flex-column">
                    <div className="pages-header mb-4 px-4 py-2">
                        <h2>Verify Email</h2>
                    </div>

                    <div className="pages-detail mb-5 px-2 sm:px-4 text-left text-lg">Please enter the verification code sent to your email address. The code will expire in 24 hours. If you don't see the email, please check your junk folder.</div>
                    <form className="form" onSubmit={onSubmit}>
                        <div className="input-panel flex flex-column px-3 mb-3 justify-content-center align-items-center">
                            <div className="p-inputgroup flex justify-content-center" style={{maxWidth: "270px"}}>
                                <span className="p-float-label">
                                    <InputText
                                        type="text"
                                        id="code"
                                        name="code"
                                        value={values.code}
                                        onChange={handleChange}
                                        autoFocus
                                    />
                                    <label htmlFor="code">Verification Code</label>
                                </span>
                            </div>
                        </div>
                        <div className="grid text-center mt-1">
                            <div className="col white-space-nowrap">
                                <Button
                                    className="login-button mb-3 px-8"
                                    label="Verify Email"
                                    icon="pi pi-check"
                                    type="submit"
                                    disabled={!changesMade || isProcessing}
                                    loading={isProcessing}
                                ></Button>
                            </div>
                        </div>
                    </form>
                    <span>
                        Need a new code? <a href="#" onClick={resendCode}>Resend Code</a>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Register;
